<section class="reminderModal__section">
  <span class="reminderModal__inputLabels">{{ 'repeat' | ppTranslate }}</span>

  <pp-point-reminder-modal-frequency-picker
    [(ppFrequency)]="ppSeries.frequency"
    [ppDisabled]="ppDisabled"
    (ppFrequencyChange)="onSeriesChange()"
    [ppDate]="date"
  ></pp-point-reminder-modal-frequency-picker>

  @if (showWarningMessage) {
    <div class="reminderModal__dateWarningContainer">
      <pp-icon
        [ppSrc]="EIconPath.ICON_BADGE_WARNING_14"
        ppClass="setSize14"
        ppColor="inherit"
        class="reminderModal__dateWarningContainer__icon"
      ></pp-icon>
      <span class="reminderModal__dateWarning">
        {{ 'reminder_date_invalid_date_1' | ppTranslate }}<span>{{ 'skip' | ppTranslate }}</span>
        {{ 'reminder_date_invalid_date_2' | ppTranslate }}</span
        >
      </div>
    }

    @if (!!ppSeries.frequency) {
      <pp-point-reminder-modal-end-date-picker
        [(ppEndDate)]="ppSeries.endDateEpochMillis"
        [ppDisabled]="ppDisabled"
        (ppEndDateChange)="onSeriesChange()"
        [ppMinDate]="date"
        (ppScrollToBottom)="onScrollToBottom()"
      ></pp-point-reminder-modal-end-date-picker>
    }
  </section>
